import React from 'react';
import PropTypes from 'prop-types';

function CreditCardIcon({ className = 'h-4 w-4 text-primary' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
    >
      <rect width='20' height='12' x='2' y='6' rx='2' />
      <circle cx='12' cy='12' r='2' />
      <path d='M6 12h.01M18 12h.01' />
    </svg>
  );
}

CreditCardIcon.propTypes = {
  className: PropTypes.string,
};

export default CreditCardIcon;
